import { bootstrap } from './bootstrap';
import AppSearch from './components/AppSearch.vue';

bootstrap(AppSearch);
